module.exports = __webpack_public_path__ + "static/media/tutorial-08.2b330f87.jpg";